import _ from "@lodash";
import { FormControl, FormControlLabel, Checkbox, Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";


const styles = theme => ({
    formGroup: {
        position: "relative",
        // maxHeight: '58px',
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
    },
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
        fontSize: "12px",
    },
    formControl: {
        borderBottom: "1px solid #e1e1e1",
        "&:last-child": {
            borderBottom: 0
        }
    }
});

class EmpresaPessoaPermissao extends XAPPComponent {

    handleChangeGrupos = (_AItem, _AFlag) => {
        const { formulario, handleChange } = this.props;
        let AFormulario = Object.assign({}, formulario);
        if (_.isNull(AFormulario.grupos)) {
            AFormulario.grupos = "";
        }

        let AArray = AFormulario.grupos.split(", ");
        if (_AFlag) {
            AArray.push("{" + _AItem + "}");
        }
        else {
            AArray.splice(_.findIndex(AArray, x => x === "{" + _AItem + "}"), 1);
        }
        AFormulario.grupos = AArray.join(", ");
        handleChange({ target: { name: "formulario", value: AFormulario } });
    };

    handleChangeTipo = (_AItem, _AFlag) => {
        const { formulario, handleChange } = this.props;
        let AFormulario = Object.assign({}, formulario);
        if (_.isNull(AFormulario.tipo)) {
            AFormulario.tipo = [];
        }

        let AArray = AFormulario.tipo;
        if (_AFlag) {
            AArray.push(_AItem);
        }
        else {
            AArray.splice(_.findIndex(AArray, x => x === _AItem), 1);
        }
        AFormulario.tipo = AArray;
        handleChange({ target: { name: "formulario", value: AFormulario } });
    };

    render() {
        const { modulos, formulario, tipos = null, classes, xappRouteParams } = this.props;

        return (
            <div className='flex flex-col w-full items-center justify-center mt-8'>
                {!_.isNull(tipos) &&
                    <div className={clsx(classes.formGroup, "flex flex-col items-center justify-center mt-12 rounded-6 lg:w-1/2 w-full")} >
                        <Typography className={classes.formGroupTitle} color="textSecondary">{"Funções"}</Typography>
                        <div className='flex flex-col w-full p-12'>
                            {_.filter(tipos, { usePermission: true }).map(item => (
                                <FormControl key={item.name} id={item.name} className={classes.formControl}>
                                    <FormControlLabel
                                        className={clsx("m-0 flex-row-reverse items-center justify-between")}
                                        control={
                                            <Checkbox
                                                className="px-8 py-4"
                                                name={item.name}
                                                type='checkbox'
                                                checked={formulario.tipo.includes(item.id)}
                                                onChange={ev => this.handleChangeTipo(item.id, ev.target.checked)}
                                            />
                                        }
                                        label={<Typography className='text-start mr-16 text-18'>{item.label}</Typography>}
                                    />
                                </FormControl>
                            ))}
                        </div>
                    </div>
                }
                <div className={clsx(classes.formGroup, "flex flex-col items-center justify-center mt-12 rounded-6 lg:w-1/2 w-full")} >
                    <Typography className={classes.formGroupTitle} color="textSecondary">{"Permissões de acesso"}</Typography>
                    <div className='flex flex-col w-full p-12'>
                        {modulos[xappRouteParams.empresa].map(item => (
                            <FormControl key={item.id} id={item.id} className={classes.formControl}>
                                <FormControlLabel
                                    className={clsx("m-0 flex-row-reverse items-center justify-between")}
                                    control={
                                        <Checkbox
                                            className="px-8 py-4"
                                            name={"grupos"}
                                            type='checkbox'
                                            checked={formulario.grupos.split(", ").includes("{" + item.value + "}")}
                                            onChange={ev => this.handleChangeGrupos(item.value, ev.target.checked)}
                                        />
                                    }
                                    label={<Typography className='text-start mr-16 text-18'>{item.title}</Typography>}
                                />
                            </FormControl>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        //  list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ Pessoa, auth }) {
    return {
        tipos: Pessoa.EmpresaPessoaReducer.tipos,
        modulos: auth.user.data.settings.modulos
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaPermissao)));
